import { CircleLoading, Container, Text, Title } from './style';

const Loading = ({ title, text }: { title?: string; text?: string }) => {
  return (
    <Container>
      <CircleLoading src={'/img/loading_2.png'} />
      <Title>{title}</Title>
      <Text>{text}</Text>
    </Container>
  );
};

export default Loading;
